import { ComponentStyles } from "types/common";

export const styles: ComponentStyles = {
  container: {
    display: "flex",
    flexDirection: "column",
    height: "calc(100vh - 5rem)",
    position: "relative",
    // overflow: "hidden",
    // maxHeight: "calc(100vh - 80px)",
    // border: "solid 10px red",
  },
  stepContainer: {
    // flex: 1,
    // height: "100%",
    position: "relative",
    flexGrow: 2,
    px: 3,
    height: "calc(100vh - 10rem)",
    overflowY: "auto",
    // maxHeight: "calc(100vh - 10rem)",
  },
  grid: {
    mt: 0,
  },
  titleBar: {
    px: 3,
    py: 1,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    // mb: 1,
    fontWeight: "bold",
    fontSize: "1.25rem",
  },
  subtitle: {
    fontSize: "0.875rem",
  },
  divider: {
    mb: 3,
  },
  tutorialBar: {
    // px: 3,
    width: "max-content",
    mb: 0,
    display: "flex",
    flexDirection: "row",
    // justifyContent: "flex-end",
    // backgroundColor: "red",
  },
  tutorialBtn: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  infoIcon: {
    verticalAlign: "-5px",
  },
  titleBarLeft: {
    display: "flex",
    alignItems: "center",
  },
  actionButtons: {
    px: 3,
    py: 2,
    display: "flex",
    justifyContent: "space-between",
  },
  rightButtons: {
    display: "flex",
  },
  backActionButton: {
    mr: 1,
    color: "text.primary",
  },
};
